import { render } from "./ManagerActions.vue?vue&type=template&id=27de0668&scoped=true"
import script from "./ManagerActions.vue?vue&type=script&lang=js"
export * from "./ManagerActions.vue?vue&type=script&lang=js"

import "./ManagerActions.vue?vue&type=style&index=0&id=27de0668&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27de0668"]])

export default __exports__